import { IntakeVsClosureReportRequestType } from '../types/reports.types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'

export const getReportsData = async (payload: IntakeVsClosureReportRequestType) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}v1/reports/generate-report`,
    payload
  )
}
